import React, { useState, useEffect } from 'react';
import './App.css';
import cartoonCoder from './cartoon-coder.png';
import profileHeadphones from './profile-headphone.jpg';
import drugmolecule from './drugmolecule.jpeg';
import game2048 from './2048-game.jpeg';
import marketmind from './marketmind.jpeg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const roles = [
  'Problem Solver',
  'Backend Developer',
  'ML & AI Enthusiast',
  'Software Engineer',
  'Full Stack Developer',
];

function App() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    let timeout;
    if (typing) {
      if (displayedText.length < roles[roleIndex].length) {
        timeout = setTimeout(() => {
          setDisplayedText(roles[roleIndex].slice(0, displayedText.length + 1));
        }, 160);
      } else {
        timeout = setTimeout(() => setTyping(false), 1500);
      }
    } else {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText(roles[roleIndex].slice(0, displayedText.length - 1));
        }, 80);
      } else {
        setTyping(true);
        setRoleIndex((roleIndex + 1) % roles.length);
      }
    }
    return () => clearTimeout(timeout);
  }, [displayedText, typing, roleIndex]);

  return (
    <div className="app-bg">
      {/* Navbar */}
      <nav className="navbar">
        <div className="logo">SD</div>
        <ul className="nav-links">
          <li><a href="#home">🏠 Home</a></li>
          <li><a href="#about">👤 About</a></li>
          <li><a href="#projects">📁 Projects</a></li>
          <li><a href="https://drive.google.com/file/d/1d1OENCip29_hotk_uIrubef9Jh5F1dDM/view?usp=sharing" target="_blank" rel="noopener noreferrer">📄 Resume</a></li>
        </ul>
        <div className="nav-actions">
          <a href="https://github.com/swatuu0602" target="_blank" rel="noopener noreferrer" className="nav-icon" title="GitHub">
            <FontAwesomeIcon icon={faGithub} size="lg" />
          </a>
          <a href="https://www.linkedin.com/in/swatita-dash-9781aa21b/" target="_blank" rel="noopener noreferrer" className="nav-icon" title="LinkedIn">
            <FontAwesomeIcon icon={faLinkedin} size="lg" />
          </a>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="hero-section" id="home">
        <div className="hero-text">
          <div className="hi-there">
            Hi There! <span className="wave-hand">👋🏻</span>
          </div>
          <h1>I'M <span className="highlight">SWATITA</span></h1>
          <h3 className="subtitle animated-subtitle">{displayedText}<span className="cursor">|</span></h3>
        </div>
        <div className="hero-img">
          <img src={cartoonCoder} alt="Cartoon Coder" />
        </div>
      </header>

      {/* About Section */}
      <section id="about" className="about-section about-two-col">
        <div className="about-text-col">
          <div className="about-tagline">
            "Where curiosity meets technology, I turn questions into breakthroughs — and ideas into impact."
          </div>
          <h2 className="section-title about-title">
            LET ME <span className="highlight">INTRODUCE</span> MYSELF
          </h2>
          <p className="about-intro">
            I am a <span className="highlight-bold">Backend Developer</span> who loves working with <span className="highlight-bold">Node.js</span>, <span className="highlight-bold">Express.js</span>, and <span className="highlight-bold">REST APIs</span>.<br />
            I am fluent in classics like <span className="highlight-bold">C</span>, <span className="highlight-bold">C++</span>, <span className="highlight-bold">JavaScript</span>, and <span className="highlight-bold">Python</span>.<br />
            My interests include building scalable backend systems, exploring <span className="highlight-bold">GraphQL</span>, and applying <span className="highlight-bold">Machine Learning</span> and <span className="highlight-bold">AI</span> to solve real-world problems.<br />
            I thrive on architecting robust, efficient, and user-friendly solutions for production-grade projects.
          </p>
        </div>
        <div className="about-img-col">
          <img src={profileHeadphones} alt="Profile" className="about-profile-img" />
        </div>
      </section>

{/* Projects */}
<section id="projects" className="projects-section">
  <h2 className="section-title projects-title">My Recent <span className="highlight">Works</span></h2>
  <p className="projects-subtitle">Here are a few projects I've worked on recently.</p>
  <div className="projects-list">
    {/* 2048 Game */}
    <div className="project-card bulge-card">
      <div className="project-img-wrap">
        <img src={game2048} alt="2048 Game" className="project-img" />
      </div>
      <h3 className="project-title">2048 Game</h3>
      <p className="project-desc">
        A fast, smooth 2048 puzzle game with 4x4 and 8x8 grids. Built in React with custom hooks and optimized CSS for a seamless, engaging experience across devices.
      </p>
      <div className="project-links">
        <a href="https://github.com/swatuu0602/2048_GAME" target="_blank" rel="noopener noreferrer" className="project-btn">GitHub</a>
        <a href="https://2048-game-weld.vercel.app/" target="_blank" rel="noopener noreferrer" className="project-btn">Demo</a>
      </div>
    </div>

    {/* DrugShield.AI */}
    {/* DrugShield.AI */}
<div className="project-card">
  <div className="project-img-wrap">
    <img src={drugmolecule} alt="DrugShield.AI Molecule" className="project-img" />
  </div>
  <h3 className="project-title">DrugShield.AI</h3>
  <p className="project-desc">
    Predicts drug toxicity using Tox21 data and graph neural networks. Built for safer pharmaceuticals and advanced computational biology.
  </p>
  <div className="project-links">
    <a href="https://github.com/swatuu0602/THE_DRUG_TOXICITY_PREDICTOR_GCN" target="_blank" rel="noopener noreferrer" className="project-btn">GitHub</a>
    <a href="https://thedrugtoxicitypredictorgcn-p55cefdugvywvdcam5mbrk.streamlit.app/" target="_blank" rel="noopener noreferrer" className="project-btn">Demo</a>
  </div>
</div>


    {/* MarketMind */}
    <div className="project-card">
      <div className="project-img-wrap">
        <img src={marketmind} alt="MarketMind" className="project-img" />
      </div>
      <h3 className="project-title">MarketMind</h3>
      <p className="project-desc">
        Web app for global sales management with predictive analytics. Features forecasting models, launch strategy optimization, and secure authentication. Built with React.js, Node.js, Express.js, MongoDB, and TypeScript.
      </p>
      <div className="project-links">
        <a href="https://github.com/swatuu0602/MarketMind/tree/master" target="_blank" rel="noopener noreferrer" className="project-btn">GitHub</a>
        <a href="https://market-mind-rouge.vercel.app/login" target="_blank" rel="noopener noreferrer" className="project-btn">Demo</a>
      </div>
    </div>
  </div>
</section>


      {/* Find Me On Section */}
      <section className="findme-section">
        <h3 className="findme-title">Find Me On</h3>
        <div className="findme-links">
          <a href="https://github.com/swatuu0602" target="_blank" rel="noopener noreferrer" className="findme-icon" title="GitHub">
            <FontAwesomeIcon icon={faGithub} size="lg" />
          </a>
          <a href="https://www.linkedin.com/in/swatita-dash-9781aa21b/" target="_blank" rel="noopener noreferrer" className="findme-icon" title="LinkedIn">
            <FontAwesomeIcon icon={faLinkedin} size="lg" />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        Made with <span className="footer-heart">❤️</span> by Swatita
      </footer>
    </div>
  );
}

export default App;
